import type React from "react";

interface SaveToCloudExportCardProps {
  onSelect: () => void;
  disabled?: boolean;
  disabledReason?: string;
}

export default function SaveToCloudExportCard({
  onSelect,
  disabled = false,
  disabledReason,
}: SaveToCloudExportCardProps) {
  return (
    <div
      className="Card"
      style={
        {
          "--card-color": "var(--color-primary)",
          "--card-color-darker": "var(--color-primary-darker)",
          "--card-color-darkest": "var(--color-primary-darkest)",
        } as React.CSSProperties
      }
      data-testid="save-to-cloud-export-card"
    >
      <div className="Card-icon">{cloudSaveIcon}</div>
      <h2>Save to cloud</h2>
      <div className="Card-details">
        {disabled && disabledReason
          ? disabledReason
          : "Save securely to your cloud storage. Open it again from Home and share it only when you choose."}
      </div>
      <button
        type="button"
        className="Card-button ToolIcon ToolIcon_type_button ToolIcon_size_medium ToolIcon_type_button--show"
        aria-label="Save to cloud"
        onClick={onSelect}
        disabled={disabled}
      >
        <div className="ToolIcon__label">Save to cloud</div>
      </button>
    </div>
  );
}

const cloudSaveIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);
